import React from 'react';
import {BaseIconProps} from '../../types';

export const BasePackageFilled: React.FC<BaseIconProps> = ({color, size}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 2.5H10V10L8.5 9L7 10V2.5ZM5.5 2.5V10C5.5 10.5532 5.80448 11.0615 6.29221 11.3225C6.77995 11.5835 7.37177 11.5549 7.83205 11.2481L8.5 10.8028L9.16795 11.2481C9.62823 11.5549 10.2201 11.5835 10.7078 11.3225C11.1955 11.0615 11.5 10.5532 11.5 10V2.5H20C21.3807 2.5 22.5 3.61929 22.5 5V18C22.5 19.3807 21.3807 20.5 20 20.5H4C2.61929 20.5 1.5 19.3807 1.5 18V5C1.5 3.61929 2.61929 2.5 4 2.5H5.5ZM5.75 16C5.75 15.5858 6.08579 15.25 6.5 15.25H11.5C11.9142 15.25 12.25 15.5858 12.25 16C12.25 16.4142 11.9142 16.75 11.5 16.75H6.5C6.08579 16.75 5.75 16.4142 5.75 16Z"
        fill={color}
      />
    </svg>
  );
};
